<template>
  <div>
    <!-- begin filters -->
    <b-card no-body class="p-0 m-b-10">
      <b-card-body class="p-10 p-b-5 p-t-5">
        <b-row>
          <b-col :cols="colsLength">
            <label class="width-full"
              ><b>Search:</b>
              <input
                v-model="search"
                placeholder="Search"
                type="search"
                class="form-control"
              />
            </label>
          </b-col>
          <!--
                <b-col :cols="colsLength" v-if="showStageFilter && stages.length">
                    <label class="width-full"><b>Stage:</b>
                        <select v-model="stageFilter" class="form-control">
                            <option value="all" selected>All</option>
                            <option v-for="stage in stages" :key="stage.id" :value="stage.id">{{ stage.name }}</option>
                        </select>
                    </label>
                </b-col>
                -->
          <b-col :cols="colsLength" class="d-flex p-b-3">
            <input-button
              type="button"
              @click="resetFilters"
              label="Reset filters"
              class="btn-yellow my-auto"
            />
          </b-col>
          <b-col class="d-flex align-self-center justify-content-end">
            <slot name="extraButtons" />
          </b-col>
        </b-row>
      </b-card-body>
      <!-- end filters -->
    </b-card>
    <div class="row">
      <!-- begin item card -->
      <b-col
        :xl="colsLength"
        :lg="6"
        class="m-b-15"
        v-for="item in currentPageItems"
        :key="item.id"
      >
        <b-card
          no-body
          class="overflow-hidden"
          :bg-variant="addToParent ? 'light' : 'dark'"
          :text-variant="addToParent ? 'dark' : 'light'"
        >
          <b-row no-gutters>
            <b-col md="6">
              <b-card-img
                :src="getImage(item.image)"
                alt="Image"
                class="rounded-0"
              ></b-card-img>
            </b-col>
            <b-col md="6" class="p-0">
              <b-card-body :title="item.name">
                <b-card-text class="m-l-5 m-r-5">
                  <p class="card-text" v-if="item.steps">
                    Steps: {{ item.steps.length }}
                  </p>
                  <p class="card-text" v-if="item.stage && stages">
                    Stage: {{ getFullStage(item.stage).name }}
                  </p>
                </b-card-text>
                <div class="text-center">
                  <input-button
                    v-if="addToParent"
                    type="button"
                    class="btn-yellow btn-sm"
                    :label="'Add'"
                    @click="addToParent(item)"
                  />
                  <div v-else>
                    <url-button
                      class="btn-yellow btn-sm"
                      label="View"
                      :url="
                        item.stage
                          ? `${itemViewUrl}${item.stage}/step/${item.id}`
                          : `${itemViewUrl}${item.id}`
                      "
                    />
                    <url-button
                      v-if="item.storyboard"
                      class="btn-gray btn-sm"
                      :label="`Set steps`"
                      :url="`/storyboard/${item.storyboard}/stage/${item.id}/plan`"
                    />
                    <input-button
                      v-if="removeFromParent"
                      type="button"
                      class="btn-light btn-sm"
                      :label="'Remove'"
                      @click="removeFromParent(item)"
                    />
                  </div>
                </div>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <!-- end item card -->
      <!-- begin no items card -->
      <b-col
        :xl="colsLength"
        :lg="6"
        class="m-b-15"
        v-if="!filterItems(items).length"
      >
        <b-card
          bg-variant="light"
          text-variant="dark"
          title="No items found"
          class="text-center h-100"
        >
          <b-card-text v-if="search || stageFilter != 'all'">
            There are no matching items to show.
          </b-card-text>
        </b-card>
      </b-col>
      <!-- end no items card -->
      <!-- begin item create card -->
      <b-col :xl="colsLength" :lg="6" class="m-b-15" v-if="addButton">
        <b-card
          bg-variant="dark"
          text-variant="light"
          :title="addButton.title"
          class="text-center h-100"
        >
          <b-card-text>
            <url-button
              class="btn-yellow text-dark btn-sm"
              :label="addButton.label"
              :url="addButton.url"
            />
          </b-card-text>
        </b-card>
      </b-col>
      <!-- end item create card -->
    </div>
    <div class="row">
      <div class="col-12">
        <b-pagination
          class="m-b-0"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="center"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UrlButton from '../../components/buttons/UrlButton.vue'
import InputButton from '../../components/buttons/InputButton.vue'

export default {
  props: [
    'items',
    'stages',
    'getImage',
    'activeStage',
    'addToParent',
    'removeFromParent',
    'itemViewUrl',
    'addButton',
    'showStageFilter',
    'colsLength',
    'perPage'
  ],
  components: {
    UrlButton,
    InputButton
  },
  computed: {
    rows() {
      return this.filterItems(this.items).length
    },
    currentPageItems() {
      let items = this.filterItems(this.items)
      let lengthAll = items.length
      let nbPages = 0
      let paginated_items = {}
      for (let i = 0; i < lengthAll; i = i + this.perPage) {
        paginated_items[nbPages] = items.slice(i, i + this.perPage)
        nbPages++
      }
      return paginated_items[this.currentPage - 1]
    }
  },
  data() {
    return {
      search: '',
      stageFilter: 'all',
      currentPage: 1
    }
  },
  methods: {
    filterItems(items) {
      let self = this
      return items.filter(function (item) {
        //if (self.showStageFilter && self.stageFilter == item.stage || self.stageFilter == "all") {
        if (
          (self.activeStage && self.activeStage.id == item.stage) ||
          (self.activeStage && !item.stage) ||
          !self.activeStage
        ) {
          if (self.search) {
            if (item.name.toLowerCase().includes(self.search.toLowerCase())) {
              return item
            }
          } else {
            return item
          }
        }
      })
    },
    resetFilters() {
      this.search = ''
      this.stageFilter = 'all'
    },
    getFullStage(stageId) {
      let stepStage = null
      if (this.stages && this.stages.length) {
        this.stages.forEach((stage) => {
          if (stage.id == stageId) {
            stepStage = stage
          }
        })
      }
      return stepStage
    }
  }
}
</script>
